import { branch, renderComponent, renderNothing } from 'recompose';
import BalanceWrapper from './BalanceWrapper';

const shouldShow = branch(
  ({ show, balance }) => show && (balance <= 10),
  renderComponent(BalanceWrapper),
  renderNothing,
);

export default shouldShow(BalanceWrapper);
